import { createContext, type ReactNode, useContext, useEffect, useState } from 'react';

interface CustomDomainContextValue {
  isCustomDomain: boolean;
  businessId: string | null;
}

const CustomDomainContext = createContext<CustomDomainContextValue>({
  isCustomDomain: false,
  businessId: null,
});

export function CustomDomainProvider({ children }: { children: ReactNode }) {
  const [value, setValue] = useState<CustomDomainContextValue>({
    isCustomDomain: false,
    businessId: null,
  });

  useEffect(() => {
    const hostname = window.location.hostname;
    const isPlatform =
      hostname.endsWith('.fiops.ai') || hostname.endsWith('.opsmatrix.dev') || hostname === 'localhost';
    if (isPlatform) return;

    const apiUrl = import.meta.env.VITE_API_URL;
    if (!apiUrl) return;

    fetch(`${apiUrl}/api/v1/website/resolve-domain`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ hostname }),
    })
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (data?.businessId) {
          setValue({ isCustomDomain: true, businessId: data.businessId });
          document.cookie = `custom-domain-business-id=${data.businessId}; path=/; max-age=86400`;
        }
      })
      .catch(() => {}); // Best-effort
  }, []);

  return <CustomDomainContext.Provider value={value}>{children}</CustomDomainContext.Provider>;
}

export const useCustomDomain = () => useContext(CustomDomainContext);
